import React from 'react';
import { THEMES } from '@americanexpress/consumer-travel-base';

const ThemeContext = React.createContext(THEMES.THEME_BLUE);

export default ThemeContext;
